
import { FormattedMessage } from 'react-intl';
import { RedCheckMarkSvg } from '@assets';

import { getSessionObj, UrlUtils } from '@share/utils';
import { ISessionKey } from '@share/common-types';
import { CONDO_SESSION_KEY } from '@constants';
import { isEmpty } from 'lodash';
import { CONDO_UNITS_SESSION_KEY_LABEL } from '@share/constants';

import './style.scss';

interface IProps {
  header: string;
  description: string;
}

export function CondoBookingFailedWarning(props: IProps) {
  const { description, header } = props;

  const values = UrlUtils.getValues();
  const sessionKey = getSessionObj(
    values[CONDO_UNITS_SESSION_KEY_LABEL] as ISessionKey,
    values[CONDO_SESSION_KEY] as ISessionKey,
  );

  return (
    <div className="condo-booking-failed-warning">
      <div className="condo-booking-failed-warning__icon">
        <RedCheckMarkSvg />
      </div>
      <div className="condo-booking-failed-warning__text">
        <div className="condo-booking-failed-warning__header">
          <FormattedMessage id={header} />
        </div>
        <div className="condo-booking-failed-warning__description">
          <FormattedMessage id={description} />
          {!isEmpty(sessionKey?.value) && 
            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
              <FormattedMessage id="session.id" values={{ sessionId: sessionKey.value }} />
            </span>}
        </div>
      </div>
    </div>
  );
}
